import axios from "./Axios";
import {
  CSV_FILE_UPLOAD_SUCCESS,
  CSV_FILE_UPLOAD_FAIL,
  FILE_UPLOAD_TRIGGERED_SUCCESS,
  RESET_ANALYSIS_REDUX_STATE,
  FETCH_CSV_SUCCESS,
  FETCH_CSV_FAIL,
  DELETE_CSV_SUCCESS,
  DELETE_CSV_FAIL,
  CSV_ANALYSIS_SUCCESS,
  CSV_ANALYSIS_FAIL,
  SENT_TO_MAIL,
  RENDER_ON_SITE,
  ADD_ANALYSIS_FILE_NAMES_TO_REDUX,
  RESET_ANALYSIS_MESSAGE_REDUX_STATE,
  FETCH_INDIVIDUAL_FILE_SUCCESS,
  FETCH_INDIVIDUAL_FILE_FAIL,
  RENDER_PDF_FILE_SUCCESS,
  RENDER_PDF_FILE_FAIL,
  ADD_ANALYSIS_FILE_ID_TO_REDUX,
  FAKE_CSV_ANALYSIS_SUCCESS,
  EDIT_ANALYSIS_OUTPUT_SUCCESS,
  EDIT_ANALYSIS_OUTPUT_FAIL,
} from "./Types";
import { returnErrors } from "./Errors";

export const UploadCSVFileAction = (file, fileType, analysisFlow, format) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const body = new FormData();
  body.append("file", file);
  if (fileType) body.append("file_type", fileType);
  if (analysisFlow) body.append("analysis_flow", analysisFlow);
  if (format) body.append("format", format);

  try {
    const res = await axios.post(`/api/analytics/upload-csv/`, body, config);

    dispatch({
      type: CSV_FILE_UPLOAD_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    console.error("File upload failed:", err.response?.data || err.message);

    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: CSV_FILE_UPLOAD_FAIL,
    });
    throw err;
  }
};

export const TriggerFileUploadAction = () => (dispatch) => {
  dispatch({ type: FILE_UPLOAD_TRIGGERED_SUCCESS });
};

export const ResetAnalysisReduxStateAction = () => (dispatch) => {
  dispatch({ type: RESET_ANALYSIS_REDUX_STATE });
};

export const FetchCSVAction = (page, fileType, pageSize) => (dispatch) => {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (fileType) params.append("file_type", fileType);
  if (pageSize) params.append("page_size", pageSize);
  const query = params.toString();
  const url = `/api/analytics/user-files/${query ? `?${query}` : ""}`;

  return axios
    .get(url)
    .then((res) => {
      dispatch({
        type: FETCH_CSV_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: FETCH_CSV_FAIL,
      });
    });
};

export const DeleteCSVAction = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/analytics/delete-csv/${id}/`);
    dispatch({ type: DELETE_CSV_SUCCESS, payload: id });
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: DELETE_CSV_FAIL });
    throw err;
  }
};

export const ResetDeleteCSVReduxStateAction = () => (dispatch) => {
  dispatch({ type: DELETE_CSV_FAIL });
};

export const ViewCSVFileAction = (fileId) => async () => {
  const res = await axios.get(`/api/analytics/download-csv/${fileId}/`, {
    responseType: "blob",
  });
  const contentDisposition = res.headers["content-disposition"] || "";
  const match = contentDisposition.match(/filename="?([^"]+)"?/);
  const fileName = match ? match[1] : `file-${fileId}`;
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const SendCSVForAnalysisAction = (id) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/analytics/send-csv-to-api/${id}/`);

    // Backend returns 202 for survey analysis (async via Celery)
    // Results will arrive via WebSocket — dispatch started, not success
    if (res.status === 202) {
      dispatch({
        type: CSV_ANALYSIS_SUCCESS,
        payload: { ...res.data, processing: true },
      });
    } else {
      dispatch({
        type: CSV_ANALYSIS_SUCCESS,
        payload: res.data,
      });
    }

    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));

    dispatch({
      type: CSV_ANALYSIS_FAIL,
    });
  }
};

export const SendToMail = () => (dispatch) => {
  dispatch({
    type: SENT_TO_MAIL,
  });
};

export const RenderOnSite = () => (dispatch) => {
  dispatch({
    type: RENDER_ON_SITE,
  });
};

export const AddAnalysisFileNamesToRedux = (fileNames) => (dispatch) => {
  dispatch({
    type: ADD_ANALYSIS_FILE_NAMES_TO_REDUX,
    payload: fileNames,
  });
};

export const ResetAnalysisMessageAction = () => (dispatch) => {
  dispatch({
    type: RESET_ANALYSIS_MESSAGE_REDUX_STATE,
  });
};

export const FetchIndividualFileAction = (id) => (dispatch) => {
  console.log("Fetching individual file with ID:", id);
  return axios
    .get(`/api/analytics/fetch-individual-file/${id}/`)
    .then((res) => {
      console.log("Received file data:", res.data);
      dispatch({
        type: FETCH_INDIVIDUAL_FILE_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      console.error("Error fetching individual file:", {
        error: err,
        response: err.response?.data,
      });
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: FETCH_INDIVIDUAL_FILE_FAIL,
      });
    });
};

export const renderFileAction = (fileId) => (dispatch) => {
  return axios
    .get(`/api/analytics/download-csv/${fileId}/`, {
      responseType: "blob", // Fetches the file as a blob
    })
    .then((res) => {
      const url = URL.createObjectURL(res.data); // Create an object URL from the blob
      dispatch({
        type: RENDER_PDF_FILE_SUCCESS,
        payload: { url, contentType: res.headers["content-type"] }, // Store URL and content type
      });
    })
    .catch((err) => {
      dispatch({
        type: RENDER_PDF_FILE_FAIL,
        payload: err.message,
      });
    });
};

export const AddAnalysisFileIDToRedux = (id) => (dispatch) => {
  dispatch({
    type: ADD_ANALYSIS_FILE_ID_TO_REDUX,
    payload: id,
  });
};

export const FakeAnalysisReduxSuccessAction = () => (dispatch) => {
  dispatch({
    type: FAKE_CSV_ANALYSIS_SUCCESS,
  });
};

export const editAnalysisOutputAction = (id, data) => async (dispatch) => {
  try {
    console.log("editAnalysisOutputAction called with:", {
      id,
      data,
      analysisOutput: data.analysis_output,
    });

    // Ensure we have valid data
    if (!data || !data.analysis_output) {
      throw new Error("No analysis output provided");
    }

    // Ensure the data is a valid object or array
    if (typeof data.analysis_output !== "object") {
      throw new Error("Analysis output must be an object or array");
    }

    const res = await axios.put(`/api/analytics/edit-analysis/${id}/`, data);

    console.log("API Response:", res.data);

    dispatch({
      type: EDIT_ANALYSIS_OUTPUT_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    console.error("Error editing analysis output:", {
      error: err,
      response: err.response?.data,
      data: data,
      stack: err.stack,
    });
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: EDIT_ANALYSIS_OUTPUT_FAIL,
    });
    throw err;
  }
};
